// @ts-ignore untyped dependency
import ReactSelectPlusSelect from 'react-select-plus';
export const {
  Async,
  Creatable,
  stripDiacritics
} = ReactSelectPlusSelect;
export const MIN_MENU_WIDTH = 144;
export const loadMoreOptionValue = '__LOAD_MORE_OPTION__';